<script>
import { VBTooltip } from 'bootstrap-vue';
import { numberFormat } from '../../helpers/numberFormat';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    score: {
      type: String,
      required: true,
    },

    points: {
      type: String,
      required: true,
    },
  },

  computed: {
    pointsNumberFormatted () {
      return numberFormat(this.points);
    },
  },
};
</script>

<template>
  <div
    class="bd-score"
    v-b-tooltip.bottom="`Total: ${pointsNumberFormatted} ${__('pontos')}`"
    :class="score.toLowerCase()"
  >
    <span
      v-text="score"
      class="bd-score__value"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '../../../sass/variables';

.bd-score {
  width: 30px;
  height: 25px;
  display: flex;
  cursor: default;
  border-radius: 12px;
  align-items: center;
  justify-content: center;

  &__value {
    margin-top: 1px;
    font-size: 1rem;
    font-weight: bold;
    font-family: $font-family-sans-serif;
  }

  &.a {
    background-color: #CDE1FB;

    .bd-score__value {
      color: #6499D9;
    }
  }

  &.b {
    background-color: #BAEBD2;

    .bd-score__value {
      color: #57B284;
    }
  }

  &.c {
    background-color: #FCE276;

    .bd-score__value {
      color: #E59516;
    }
  }

  &.d {
    background-color: #F7B1DC;

    .bd-score__value {
      color: #D53F8A;
    }
  }
}
</style>
